import React, { useState } from "react";
import styles from "./index.module.css";
import { Link, useNavigate } from "react-router-dom";
import Wrapper from "../../components/UI/wrapper";
import { BackArrow } from "../../icons";
import registrationCheck from "../../api/registrationCheck";
import Loading from "../../components/loading";

const SuccessMessage = <div>
  <p>Hörmətli iştirakçı</p>
  <br />
  <p>
    Uşaq İncəsənət Festivalında iştirak etdiyiniz üçün təşəkkür edirik!
    Siz tələb olunan keçid balını toplayaraq festivalın final mərhələsində iştirak etmək hüququ qazanmısınız. Final mərhələsinin məkan və tarixi barədə əlavə məlumat veriləcəkdir. Uğurlar arzu edirik!
  </p>
</div>

const FailedMessage = <div>
  <p>Hörmətli iştirakçı</p>
  <br />
  <p>
    Uşaq İncəsənət Festivalında iştirak etdiyiniz üçün təşəkkür edirik!
    Təəssüf ki, Siz ikinci mərhələ üzrə yekun qiymətləndirmənin nəticələrinə uyğun olaraq festivalın final mərhələsinə keçə bilməmisiniz. Növbəti festivallarımızda yenidən görüşmək ümidi ilə Sizə uğurlar arzu edirik!
  </p>
</div>

const RegistrationCheck = () => {
  const [regType, setRegType] = useState(1);
  const [personalRegType, setPersonalRegType] = useState(null);
  const [personalInput, setPersonalInput] = useState(null);
  const [collectiveRegType, setCollectiveRegType] = useState(null);
  const [collectiveInput, setCollectiveInput] = useState(null);
  const [response, setResponse] = useState(null);
  const [responseText, setResponseText] = useState(null);
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)

  // 2ci merhele neticesini mueyyen etmek ucun state (1- ugurlu, 2-ugursuz)
  const [resultType, setResultType] = useState(null)

  const handlePersonalRegType = (e) => {
    setPersonalRegType(e.target.value);
  };
  const handlePersonalInput = (e) => {
    setPersonalInput(e.target.value);
  };
  const handleCollectiveRegType = (e) => {
    setCollectiveRegType(e.target.value);
  };
  const handleCollectiveInput = (e) => {
    setCollectiveInput(e.target.value);
  };
  const getPersonalPlaceholder = () => {
    if (personalRegType === "fin") return "Fin kod";
    if (personalRegType === "birth") return "Doğum haqqında şəhadətnamə";
    if (personalRegType === "id") return "Qeydiyyat kodu";
    return "";
  };
  const getCollectivePlaceholder = () => {
    if (collectiveRegType === "fin") return "Fin kod";
    if (collectiveRegType === "id") return "Qeydiyyat kodu";
    return "";
  };

  async function getResult() {
    setResponseText(null);
    const query = {
      type: regType === 1 ? "personal" : "collective",
      document: personalRegType ? personalRegType : collectiveRegType,
      value: personalInput ? personalInput : collectiveInput,
    };
    if (regType === 1) {
      setLoading(true)
      const data = await registrationCheck
        .checkPersonalResult(query)
        .then((response) => {
          const user = response.data;
          setResultType(user.message)
          if (
            response.data.message === "Məlumat tapılmadı!" ||
            response.data.message === "Səhv sorğu !!!"
          ) {
            setResponse(response.data.message);
          } else {
            setResponse("");
            setResponseText(
              ""
            );
            // sessionStorage.setItem("userData", JSON.stringify(user));
            // navigate('/registration-check-details')
          }
        })
        .catch((error) => {
          console.log(error);
        }).finally(() => setLoading(false));
    } else {
      setLoading(true)
      const data = await registrationCheck
        .checkCollectiveResult(query)
        .then((response) => {
          const user = response.data
          setResultType(user.message)
          if (
            response.data.message === "Məlumat tapılmadı!" ||
            response.data.message === "Səhv sorğu !!!"
          ) {
            setResponse(response.data.message);
          } else {
            setResponse("");
            setResponseText(
              ""
            );
            // sessionStorage.setItem("userData", JSON.stringify(user));
            // navigate('/registration-check-details')
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => setLoading(false));
    }
  }

  async function getReg() {
    setResponseText(null);
    const query = {
      type: regType === 1 ? "personal" : "collective",
      document: personalRegType ? personalRegType : collectiveRegType,
      value: personalInput ? personalInput : collectiveInput,
    };
    if (regType === 1) {
      const data = await registrationCheck
        .getTimePlacePersonal(query)
        .then((response) => {
          const user = response.data
          console.log(response)
          if (
            response.data.message === "Məlumat tapılmadı!" ||
            response.data.message === "Səhv sorğu !!!"
          ) {
            setResponse(response.data.message);
          } else {
            setResponse("Qeydiyyat kodunuz: " + response.data.message);
            setResponseText(
              "Daxil etdiyiniz məlumata əsasən qeydiyyat uğurla tamamlanmışdır."
            );
            sessionStorage.setItem("userData", JSON.stringify(user));
            navigate('/registration-check-details')
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      const data = await registrationCheck
        .getTimePlaceCollective(query)
        .then((response) => {
          const user = response.data
          if (
            response.data.message === "Məlumat tapılmadı!" ||
            response.data.message === "Səhv sorğu !!!"
          ) {
            setResponse(response.data.message);
          } else {
            setResponse("Qeydiyyat kodunuz: " + response.data.message);
            setResponseText(
              "Daxil etdiyiniz məlumata əsasən qeydiyyat uğurla tamamlanmışdır."
            );
            sessionStorage.setItem("userData", JSON.stringify(user));
            navigate('/registration-check-details')
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }
  return (
    <>
      {loading && <Loading />}
      <Wrapper>
        <Link to={"/"} className={styles["go-back"]}>
          <BackArrow />
          <p>Geri qayıt</p>
        </Link>
      </Wrapper>
      <Wrapper>
        <div className={styles["done-container"]}>
          <div className={styles["done"]}>
            <h3>Nəticəni yoxla</h3>
            <div>
              <button
                className={
                  styles[
                  `${regType == 1 ? "tab-buttons-active" : "tab-buttons"}`
                  ]
                }
                onClick={() => {
                  setRegType(1);
                  setCollectiveInput("");
                  setCollectiveRegType("");
                  setPersonalInput("");
                  setPersonalRegType("");
                }}
              >
                Fərdi
              </button>
              <button
                className={
                  styles[
                  `${regType == 2 ? "tab-buttons-active" : "tab-buttons"}`
                  ]
                }
                onClick={() => {
                  setRegType(2);
                  setPersonalInput("");
                  setPersonalRegType("");
                  setCollectiveInput("");
                  setCollectiveRegType("");
                }}
              >
                Kollektiv
              </button>
            </div>
            {regType == 1 ? (
              <>
                <div className={styles["inputs"]}>
                  <label htmlFor="">Qeydiyyatın tipi</label>
                  <select
                    name=""
                    id=""
                    onChange={(e) => handlePersonalRegType(e)}
                    value={personalRegType}
                  >
                    <option value="" disabled selected>
                      Qeydiyyatın tipi
                    </option>
                    <option value="fin_code">İştirakçının fin kodu</option>
                    {/* <option value="birth_card">
                      İştirakçının doğum haqqında şəhadətnaməsi
                    </option> */}
                    <option value="id_code">İştirakçının qeydiyyat kodu</option>
                  </select>
                </div>
                <div className={styles["inputs"]}>
                  <input
                    type={personalRegType === "id" ? "number" : "text"}
                    placeholder={getPersonalPlaceholder()}
                    onChange={(e) => handlePersonalInput(e)}
                    disabled={personalRegType ? false : true}
                    value={personalInput}
                  />
                </div>
              </>
            ) : (
              <>
                <div className={styles["inputs"]}>
                  <label htmlFor="">Qeydiyyatın tipi</label>
                  <select
                    name=""
                    id=""
                    onChange={(e) => handleCollectiveRegType(e)}
                    value={collectiveRegType}
                  >
                    <option value="" disabled selected>
                      Qeydiyyatın tipi
                    </option>
                    <option value="col_fin_code">
                      Kollektiv rəhbərinin fin kodu
                    </option>
                    <option value="col_id_code">
                      Kollektivin qeydiyyat kodu
                    </option>
                  </select>
                </div>
                <div className={styles["inputs"]}>
                  <input
                    type={collectiveRegType === "id" ? "number" : "text"}
                    placeholder={getCollectivePlaceholder()}
                    onChange={(e) => handleCollectiveInput(e)}
                    disabled={collectiveRegType ? false : true}
                    value={collectiveInput}
                  />
                </div>
              </>
            )}
            <div className={styles["next-container"]}>
              <button
                type="button"
                className={styles["next"]}
                onClick={() => getReg()}
              >
                Yoxla
              </button>
            </div>
            {resultType == 1 && SuccessMessage}
            {resultType == 2 && FailedMessage}
            {response ? (
              <>
                {responseText ? <h3>{responseText}</h3> : null}
                <h3>{response}</h3>
              </>
            ) : null}
          </div>
        </div>
      </Wrapper>
    </>
  );
};

export default RegistrationCheck;
